import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import EmojiPicker, { Theme } from "emoji-picker-react";

interface EmojiPickerProps {
  position: { x: number; y: number };
  isDragging: boolean;
  onMouseDown: (event: React.MouseEvent) => void;
  onClose: () => void;
  onEmojiSelect: (emojiData: any) => void;
}

const EmojiPickerPopup: React.FC<EmojiPickerProps> = ({
  position,
  isDragging,
  onMouseDown,
  onClose,
  onEmojiSelect,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100); // Delay for smooth appearance
    return () => clearTimeout(timer);
  }, []);

  if (!isLoaded) {
    return null; // Render nothing until fully loaded
  }

  return (
    <div
      className="emoji-picker"
      style={{
        position: "absolute",
        top: position.y,
        left: position.x,
        cursor: isDragging ? "grabbing" : "grab",
      }}
      onMouseDown={onMouseDown}
    >
      <div className="emoji-picker-close">
        <IoClose
          size={20}
          color="#c0c0c0"
          style={{ cursor: "pointer" }}
          onClick={onClose}
        />
      </div>
      <EmojiPicker
        skinTonesDisabled={true}
        theme={Theme.DARK}
        onEmojiClick={onEmojiSelect}
      />
    </div>
  );
};

export default EmojiPickerPopup;
